import Swiper from "swiper";

const imageSlider = document.querySelector(".thumb-gallery-slider");

if (imageSlider) {
  const swiper = new Swiper(".thumb-gallery-slider", {
    loop: true,
    slidesPerView: 4,
    allowTouchMove: false,
  });
  const swiper2 = new Swiper(" .main-gallery-slider", {
    loop: true,
    centeredSlides: true,
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
}
